// src/services/guards/telephonyDriftGuard.js
// Emits Sentry warnings if telephony paths drift from the normalized location.

import * as Sentry from '@sentry/browser';

export const assertTelephonyPathNormalized = (pathLike, businessId) => {
  if (!pathLike || !businessId) {
    return;
  }

  const expected = `businesses/${businessId}/telephonyProfile/profile`;

  if (pathLike.includes('/tenants/')) {
    Sentry.withScope((scope) => {
      scope.setLevel('warning');
      scope.setTag('telephony.drift', 'tenants-path-detected');
      scope.setContext('drift', { pathLike, expected, businessId });
      Sentry.captureMessage('Telephony path drift: tenants path used');
    });

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[TelephonyDrift] tenants path detected:', { pathLike, expected });
    }
  }
};
